export default __webpack_public_path__ + "static/media/microflow_2.04071150.png";